import type { DeviceModel } from "./types";

/**
 * Resolves a device's raw model code to its friendly catalog name
 * (e.g. "safe-t-hdv-two-way-comms" -> "HDV (Two-Way Comms)"). Falls back to
 * the raw code when the model isn't in the catalog so nothing ever disappears,
 * and to "" when there is no model (callers render their own placeholder).
 */
export function deviceModelLabel(
  modelCode: string | null | undefined,
  models: ReadonlyArray<Pick<DeviceModel, "modelCode" | "name">>,
): string {
  if (!modelCode) return "";
  return models.find((m) => m.modelCode === modelCode)?.name ?? modelCode;
}
